import { Component, OnInit, Inject } from '@angular/core';
import { IUrlReplaceService, IFwkEnvironment } from 'local-fwk-common';

@Component({
  selector: 'app-shell-empty-container',
  templateUrl: './empty-container.component.html',
})
export class EmptyContainerComponent {}
